import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { ReorderContributorPlaylistDto } from '@/types/dtos/contributors/request/reorder-contributor-playlist.dto.ts';
import type { ContributorPlaylistDto } from '@/types/dtos/contributors/contributor-playlist.dto.ts';
import { patchContributorPlaylistInQueryCache } from '@/state/mutations/contributors/patch-contributor-playlist-cache.ts';

export const useReorderContributorPlaylistMutation = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ playlistId, ...body }: ReorderContributorPlaylistDto & { playlistId: string }) => {
      const token = await getToken();
      const updatedPlaylist = await reorderContributorPlaylist(playlistId, body, token ?? '');
      try {
        patchContributorPlaylistInQueryCache(queryClient, updatedPlaylist);
      } catch (error) {
        console.error('[contributor-playlist] cache patch failed after successful reorder', error);
      }
      return updatedPlaylist;
    },
  });
};

const reorderContributorPlaylist = async (
  playlistId: string,
  body: ReorderContributorPlaylistDto,
  token: string,
): Promise<ContributorPlaylistDto> => {
  const url = `${import.meta.env.VITE_API_URL}/contributor-playlists/${playlistId}/reorder`;
  return sendJSONRequest({ url, method: METHOD.PATCH, body, token });
};
